import React from 'react';
import { Portal, Snackbar } from '@mui/material';

/**
 * Snackbar rendered in a portal so it appears above modals/dialogs.
 * MUI Snackbar does not portal by default in v7.
 */
const PortalSnackbar = React.forwardRef(function PortalSnackbar(props, ref) {
  return (
    <Portal>
      <Snackbar ref={ref} {...props} />
    </Portal>
  );
});

export default PortalSnackbar;
